import $ from 'jquery';
import 'jquery';
import './bootstrap';


import initSliders from "./frontend/slider";
import scrollDown from "./frontend/scrollDown";
import triggerModal from "./frontend/modal";
import scrollTop from "./frontend/top";
import consentmanager from "./frontend/consentmanager";

$(document).ready(() => {
    initSliders();
    scrollDown();
    triggerModal();
    scrollTop();
    consentmanager();
});